import { Badge, Text } from '@dixa/lib-shared-habla';

import type { ScopeVars } from '../../types/scope';

import styles from './connectorTooltip.module.scss';

type Props = {
  isDependant: boolean;
  needs: ScopeVars['needs'];
};

export function TooltipContent({ isDependant, needs }: Props): JSX.Element {
  return (
    <div className={styles.root}>
      <Text.Paragraph>
        {isDependant
          ? 'You can’t detach this action, as it relies on the following dependencies:'
          : 'You can’t detach this action, as one or more actions beneath rely on the following dependencies:'}
      </Text.Paragraph>
      <div className={styles.badges}>
        {needs.map((need) => (
          <Badge key={need} variant="primary" size="medium">
            {need}
          </Badge>
        ))}
      </div>
    </div>
  );
}
